import { cardId, type GameView, type TrickPlay } from '@crew/shared';

/** Compare only public, authoritative state. Chat/connection snapshots are not moves. */
export function tableTransition(before: GameView, after: GameView) {
  const reset = before.missionId !== after.missionId || before.attempt !== after.attempt;
  const completed = !reset && after.lastTrick && after.lastTrick.number !== before.lastTrick?.number
    ? after.lastTrick : null;
  const plays: TrickPlay[] = [];
  if (!reset) {
    // The server clears currentTrick on the closing play; read lastTrick first.
    for (const trick of [completed && { number: completed.number, plays: completed.plays },
      { number: after.trickNumber, plays: after.currentTrick }]) {
      if (!trick) continue;
      for (const play of trick.plays) {
        const known = before.trickNumber === trick.number ? before.currentTrick
          : before.lastTrick?.number === trick.number ? before.lastTrick.plays : [];
        if (!known.some((p) => p.playerId === play.playerId && cardId(p.card) === cardId(play.card)) &&
          !plays.some((p) => p.playerId === play.playerId && cardId(p.card) === cardId(play.card))) {
          plays.push(play);
        }
      }
    }
  }
  const tasks = reset ? [] : after.tasks.flatMap((task) => {
    const old = before.tasks.find((t) => t.id === task.id);
    if (!old) return [];
    if (old.completedAt === null && task.completedAt !== null) return [{ task, playerId: task.ownerId, action: 'completed' }];
    if (old.ownerId !== task.ownerId) return [{ task, playerId: task.ownerId ?? old.ownerId, action: task.ownerId ? 'claimed' : 'released' }];
    return [];
  });
  return { reset, completed, plays, tasks };
}